//
// Copyright (c) 2024 Comcast
//

import { useDispatch } from 'react-redux'
import { operationStart, operationEnd } from 'reducers/modalForm'

export function useModalFormOperation (operation) {
  const dispatch = useDispatch()

  async function operationInModal (params) {
    dispatch(operationStart())

    const result = await operation(params)
    const successful = !result.data.error

    dispatch(operationEnd({ successful: successful }))
    return result
  }

  return operationInModal
}
